// @ts-nocheck
/* eslint-disable */
export const llaPlatformArrowSouthWestIcon = {
    data: `<svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.0625 2.5625V8.9375H7.4375" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.25 8.75L8.9375 1.0625" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-south-west' as const
};